export type Products =
  | "Print"
  | "Video"
  | "Magazines"
  | "Digital"
  | "Other";

export interface SplitRowEvent {
  value: number;
  clientPays: number;
  discount: number;
  effectiveDiscount: string;
  casualRateValue: number;
  product: Products;
}

export const getBlankSplitRow = (product: Products): SplitRowEvent => {
  return {
    value: 0,
    clientPays: 0,
    discount: 0,
    effectiveDiscount: "",
    casualRateValue: 0,
    product
  };
};
